import { AnalyticsContext, AnalyticsFilterType } from '../../AnalyticsContext'
import React from 'react'
import { ButtonDark } from '../../../../components'
import IconFont, {
  SimpleLineIconsTypes
} from '../../../../components/common/IconFont'
import { AnalyticsFiltersEnum } from '../../constants'
import {
  ModalFilterEntitiesControlContext,
  ModalFilterEntitiesEnum
} from '../../../../components/common/entityFiltersModals'

type ShowFilterModalButtonProps = {
  modalId: ModalFilterEntitiesEnum
  filterKey?: keyof AnalyticsFilterType
  filterId?: AnalyticsFiltersEnum
  activeFilters?: Array<AnalyticsFiltersEnum>
  icon?: SimpleLineIconsTypes
  persistent?: boolean
}
export const ShowFilterModalButton: React.FC<ShowFilterModalButtonProps> = ({
  modalId,
  children,
  filterKey,
  activeFilters,
  filterId,
  icon = 'close',
  persistent
}) => {
  const { showModal } = React.useContext(ModalFilterEntitiesControlContext)
  const { filter, changeFilter } = React.useContext(AnalyticsContext)

  const removeFilter = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    if (filterKey) {
      changeFilter({ [filterKey]: null })
    }
  }

  if (!persistent) {
    if (filterKey && !filter[filterKey]) {
      return null
    }
    if (activeFilters && filterId && !activeFilters.includes(filterId)) {
      return null
    }
  }

  return (
    <ButtonDark
      className="AnalyticsFilter__item"
      onClick={() => showModal(modalId)}
    >
      <span className="AnalyticsFilter__item__label">{children}</span>
      <span className="AnalyticsFilter__item__icon">
        <IconFont type={icon} onClick={persistent ? undefined : removeFilter} />
      </span>
    </ButtonDark>
  )
}
